import { render, staticRenderFns } from "./tenderTrain.vue?vue&type=template&id=23774544&scoped=true&"
import script from "./tenderTrain.vue?vue&type=script&lang=js&"
export * from "./tenderTrain.vue?vue&type=script&lang=js&"
import style0 from "./tenderTrain.vue?vue&type=style&index=0&id=23774544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23774544",
  null
  
)

export default component.exports